import { withHost } from 'utils';

export const Api = {
  FetchUserProfile: (userId) => withHost(`/datasets/artists/record/${userId}`),
  CreateProfile: withHost(`/datasets/artists`),
  UpdateProfile: (userProfileId) => withHost(`/datasets/id/${userProfileId}`),
  ImageUploadUrl: withHost('/files/upload'),
};
